const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://yabatho-api.onrender.com/v2/api';

export const getProfilePhoto = user => {
  const raw = user?.photo || user?.picture || user?.profileImage ||
    user?.profilePicture || user?.photoUrl || user?.avatar || '';

  if (typeof raw !== 'string' || !raw.trim()) return '';

  const value = raw.trim();
  if (value.startsWith('//')) return `https:${value}`;
  if (/^https?:\/\//i.test(value)) {
    return window.location.protocol === 'https:'
      ? value.replace(/^http:\/\//i, 'https://')
      : value;
  }

  try {
    return new URL(value, API_BASE_URL.replace(/\/v\d+\/api\/?$/i, '/')).toString();
  } catch (_) {
    return '';
  }
};
